import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Repairs from "@/pages/Repairs";
import Fitting from "@/pages/Fitting";
import Events from "@/pages/Events";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Detect session_id in URL fragment SYNCHRONOUSLY during render
  // (useEffect runs after render — too late). This handles OAuth callback first.
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/repairs" element={<Repairs />} />
        <Route path="/fitting" element={<Fitting />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function App() {
  useEffect(() => {
    document.title = "Last Stop Bike Shop — St. Louis";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
